export const CHART_TYPES = Object.freeze({
  bookType: 'Book Type',
  documentType: 'Document Type',
  reviewed: 'Review Type',
  curative: 'Curative Type',
} as const);

export type ChartTypes = (typeof CHART_TYPES)[keyof typeof CHART_TYPES];
